export default __webpack_public_path__ + "static/media/fraud-report.20be7b88.svg";